const url = "https://api.unificacred.com.br";

export default url;
